function IconComplete() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="14" height="14" rx="4" fill="#ABCBFC" />
      <rect width="14" height="14" rx="4" fill="#ABCBFC" />
      <path
        d="M2.82608 5.99133L5.79347 9.0435L10.7391 3.95654"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
export default IconComplete;
